import { Language } from "utils/language";

export const MENU_NAV: Record<Language, string> = {
  en: "/asset/content/nav-api/enus_mainmenu.nav.json",
  ja: "/asset/content/nav-api/jajp_mainmenu.nav.json",
  "zh-cn": "/asset/content/nav-api/zhcn_mainmenu.nav.json",
};
